// Maps Issues table sorting to Alert Vault's sort_by/sort_order.
const SORT_FIELDS: Record<string, string> = {
  entity_name: 'entity_name',
  severity: 'severity',
  resource: 'resource_type',
  last_seen: 'last_seen',
};

// The table and the legacy notification API both flip direction: the table
// labels its 'desc' state "Ascending" and legacy sorts it ascending. Keep that
// so the arrow matches the rows.
export const alertVaultSort = (
  field?: string | null,
  order?: string | null,
): { sortBy?: string; sortOrder?: 'asc' | 'desc' } => {
  const sortBy = field ? SORT_FIELDS[field] : undefined;
  if (!sortBy || !order) return {};
  return { sortBy, sortOrder: order === 'desc' ? 'asc' : 'desc' };
};
